import React from "react";
import { Radio } from "antd";
import { Field, ErrorMessage } from "formik";
import TextError from "./TextError";

function RadioButtons({ label, name, options = [], ...rest }) {

  return (
    <div className="mb-1">
      <div className="mb-1">
        <label htmlFor={name}>{label}</label>
      </div>
      <Field name={name}>
        {({ field, form }) => (
          <Radio.Group
            id={name}
            {...rest}
            value={field.value}
            onChange={(e) => form.setFieldValue(name, e.target.value)}
            onBlur={() => form.setFieldTouched(name, true)}
          >
            {options.map((option) => (
              <Radio key={option.value} value={option.value}>
                {option.label}
              </Radio>
            ))}
          </Radio.Group>
        )}
      </Field>
      <ErrorMessage component={TextError} name={name} />
    </div>
  );
}

export default RadioButtons;
